<template>
	<div class="app" style="width: 100%;">
		<el-container direction="vertical">
			<el-header style="padding:0;height: auto;">
				<IndexHead style="width:100%;"></IndexHead>
			</el-header>
			<el-main style="padding:0;">
				<div class="text color flex justify-align-center" style="font-size: 23px;height:45px;margin-top: 30px;">
					VIP会员权益
				</div>
				<div class="text flex justify-align-center" style="font-size: 14px;height:20px;color:#999999">更多特权 超值服务
				</div>
				<div class="content flex  justify-center" style="width:70%;margin: 0 auto;">
					<div
						style="width:340px;height:300px;border-radius: 20px;border:1px solid #EBEEF5;margin-top: 20px;overflow: hidden;text-align: center;">
						<div class="flex direction-column align-center justify-center"
							style="height:120px;background:#f6cda0;color:#954608">
							<div style="font-weight: 700;font-size:20px;">VIP会员</div>
							<div style="font-size: 16px;margin-top: 20px;">商务人士超值之选</div>
						</div>
						<div class="flex space-around" style="width: 100%;margin-top: 25px;">
							<div v-for="(item,index) in viplist" :key="index" @click="clickprice(index)"
								class="flex align-center font xiaoshou"
								style="position: relative;color:#954608; padding:18px 13px;border-radius: 5px;"
								:class="tuiIndex==index?'border':'borders'">
								<img v-if="item.recommend_flag ==1" src="../assets/img/vip1.png"
									style="width:29px;height:17px;position: absolute;top:-5px;left:0px ;z-index: 9;" />
								<img v-if="tuiIndex==index" src="../assets/img/vip2.png"
									style="width:97px;height:63px;position: absolute;top:0px;left:0px;z-index: -1;" />
								<div class="flex all-align-end">
									￥<div style="font-size:19px ;">{{parseInt(item.price)}}</div>
									<div style="color:#aaaaaa">/{{item.term}}{{item.term_unit}}</div>
								</div>
							</div>
						</div>
						<el-button type="text" @click="open"
							style="color:#954608;background:#f6cda0; padding:7px ;width:60%;border-radius: 4px;text-align: center;margin:30px auto;">
							立即开通</el-button>
						<el-dialog title="扫码支付" :visible.sync="userVisible" width="30%" style="padding:10px">
							<!-- <div class="flex space-between align-center" style="border-bottom: 1px solid #EBEEF5;height: 50px;">
								<div class="font">电子发票：</div>
								<textarea type="text" v-model="piaoinfo" placeholder="" style="width:200px;height: 35px;border: none;resize: none;"/>
							</div> -->
							<p style="font-size: 13px;color: #999999;text-align: left;">如需要电子发票,请填写发票信息,如不需要可不填(非必填)</p>
							<div class="flex space-between align-center" style="border-bottom: 1px solid #EBEEF5;height: 50px;">
								<div class="font">企业名称：</div>
								<input style="text-align: right;border: none;" placeholder="如需申请发票请填写" v-model="qiyeming" />
							</div>
							<div class="flex space-between align-center" style="border-bottom: 1px solid #EBEEF5;height: 50px;">
								<div class="font">税号：</div>
								<input style="text-align: right;border: none;" placeholder="如需申请发票请填写" v-model="shuihao" />
							</div>
							<div class="flex space-between align-center" style="border-bottom: 1px solid #EBEEF5  ;height: 50px;">
								<div class="font">应付金额：</div>
								<div style="color:red;font-size: 12px;">￥<span style="font-size: 18px;">{{price}}</span></div>
							</div>
							<div class="flex space-between align-center" style="border-bottom: 1px solid #EBEEF5  ;height: 50px;">
								<div class="font">支付方式：</div>
								<div class="flex">
									<div :class="zhifufs==1?'border':'border1'" style="margin-right: 30px;border-radius: 3px;padding:4px;width:95px;position: relative;z-index:9;" class="flex align-center xiaoshou" @click="baozf()">
										<img v-if="zhifufs==1" src="../assets/img/zf5.png" style="width:106px;position: absolute;z-index:-1;left: 0;top:0"/>
										<img src="../assets/img/zf3.png" style="width:20px;height:20px; margin-right: 5px;"/>
										支付宝支付
									</div>
									<div :class="zhifufs==2?'border':'border1'" class="flex align-center justify-center xiaoshou" style="border-radius: 3px;padding:4px;width:95px;position: relative;z-index:9" @click="weixinzf()" >
										<img v-if="zhifufs==2" src="../assets/img/zf5.png" style="width:106px;position: absolute;z-index: -1;left: 0;top:0"/>
										<img src="../assets/img/zf2.png" style="width:20px;height:20px;margin-right: 5px;"/>
										微信支付
									</div>
								</div>
							</div>
							<el-button style="margin-top: 20px;width: 300px;" v-show="!erweimaShow" @click="chuanjian">创建订单</el-button>
							<div class="flex justify-align-center direction-column" style="padding:20px" v-show="erweimaShow">
								<img v-if="zhifufs == 2" :src="wx_pay" style="width:120px;height:120px;" />
								<img v-if="zhifufs == 1" :src="zfb_pay" style="width:120px;height:120px;" />
								<div class="font" style="margin-top:10px;">请立即扫码，支付成功后自动开通服务</div>
							</div>
						</el-dialog>
				</div>
	     	</div>
				<el-row type="flex" justify="center">
					<el-col :span="22">
			<div class=" biao" style="margin: 40px auto;">
				<el-table :data="tableData" border style="width: 100%" class="font">
					<el-table-column prop="quanx" label="功能权限" width="450" align="left">
					</el-table-column>
					<el-table-column prop="puhui" label="普通会员" align="center">
						<template slot-scope="scope">
							 <img v-if="scope.row.puhui==1" src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
							 <img v-if="scope.row.puhui==0" src="../assets/img/zf1.png" style="width:14px;height:14px;"></img>
							 <div  v-if="scope.row.puhui!=1&&scope.row.puhui!=0">{{scope.row.puhui}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="viphui" align="center" label="vip会员">
						<template slot-scope="scope">
							 <img v-if="scope.row.viphui==1" src="../assets/img/dui1.png" style="width:14px;height:14px;"></img>
							 <img v-if="scope.row.viphui==0" src="../assets/img/zf1.png" style="width:14px;height:14px;"></img>
							 <div  v-if="scope.row.viphui!=1&&scope.row.viphui!=0">{{scope.row.viphui}}</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			</el-col>
			</el-row>
			</el-main>
			<el-footer style="padding:0;height: 30px;margin-top: 60px;">
				<div class="font"
					style="width:100%;background: #282828;height: 50px;color:#ffffff;line-height: 50px;text-align: center;">
					版权所有：HR校招助手网 <span style="width: 100px;display: inline-block;"></span> CNZZ
				</div>
			</el-footer>
		</el-container>
		<div style="height: 50px;width: 100%;"></div>
	</div>
</template>

<script>
	import IndexHead from '../components/IndexHead.vue';
	export default {
		name: 'index',
		components: {
			IndexHead
		},
		data() {
			return {
				erweimaShow: false,
				qiyeming: '',
				shuihao: '',
				tuiIndex: '1',
				viplist: [{
					money: '630',
					year: '2年',
					tui:1
				}, {
					money: '360',
					year: '1年',
					tui:''
				}, {
					money: '298',
					year: '半年',
					tui:''
				}, ],
				tableData: [{
					quanx: '报名双选会',
					puhui: '0',
					viphui: '1'
				}, {
					quanx: '院校搜索结果',
					puhui: '3条',
					viphui: '不限'
				}, {
					quanx: '收藏功能',
					puhui: '0',
					viphui: '1'
				},{
					quanx: '关注功能 (vip会员可关注70所学院，及时收到 双选会信息投送)',
					puhui: '0',
					viphui: '1'
				},{
					quanx: '查就业办手机号',
					puhui: '0',
					viphui: '1'
				},{
					quanx: '查就业办固话',
					puhui: '1',
					viphui: '1'
				},{
					quanx: '查生源信息',
					puhui: '1',
					viphui: '1'
				},{
					quanx: '查校企交流群',
					puhui: '1',
					viphui: '1'
				},{
					quanx: '查就业办微信公众号',
					puhui: '1',
					viphui: '1'
				},{
					quanx: '查校招指南',
					puhui: '1',
					viphui: '1'
				},  ],
				// 判断弹窗是否弹出
				userVisible:false,
				// 发票信息
				piaoinfo:'',
				// 应付金额
				price: '',
				// 支付方式选择
				zhifufs:1,
				wx_pay: '',
				zfb_pay: ''
			}
		},
		mounted() {
			this.packagelist();
			this.$axios.get('/api/site/conf').then(res => {
				this.wx_pay = res.data.data.wx_pay_qr
				this.zfb_pay = res.data.data.zfb_pay_qr
				this.tableData[1].puhui = `${res.data.data.user_search_limit}条`
				this.tableData[3].quanx = `关注功能 (vip会员可关注${res.data.data.vip_follow_limit}所学院，及时收到 双选会信息投送)`
			})
		},
		watch: {
			userVisible(val){
				if(!val){
					this.shuihao = '';
					this.qiyeming = '';
					this.erweimaShow = false;
				}
			}
		},
		methods: {
			chuanjian(){
				this.$axios.post('/api/order/add',{
					api_token: window.localStorage.getItem('token'),
					invoice_sn: this.shuihao,
					invoice_name: this.qiyeming,
					pay_money: this.viplist[this.tuiIndex].price,
					pay_type: this.zhifufs == 1 ? '支付宝' : '微信',
					vip_product_id: this.viplist[this.tuiIndex].id
				}).then(res => {
					if(res.data.code == 200){
						this.erweimaShow = true;
					}
				})
			},
			// 打开弹窗
			open() {
				this.userVisible=true;
			},
			// 获取支付价格
			clickprice(index){
				this.tuiIndex=index;
				this.price=this.viplist[index].price;
			},
			// 微信支付
			weixinzf(){
				this.zhifufs=2
				this.erweimaShow = false;
			},
			// 支付宝支付
			baozf(){
				this.zhifufs=1;
				this.erweimaShow = false;
			},
			//套餐列表
			packagelist(){
				this.$axios
					.get(`/api/vip/products`)
					.then((res) => {
						// console.log(res,"res");
						this.viplist=res.data.data;
						this.price = res.data.data[1].price
					});
			}
		}
	}
</script>
<style lang="less">
	#app {
		font-family: Avenir, Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		// text-align: center;
		color: #2c3e50;
	}

	#navs {
		display: flex;
		justify-content: space-around;
	}

	#nav {
		a {
			font-weight: bold;
			color: #2c3e50;

			&.router-link-exact-active {
				color: #42b983;
			}
		}
	}

	.border {
		border: 1px solid transparent;
	}

	.borders {
		border: 1px solid #EBEEF5;
	}
	.border1{
		border: 1px solid #aaaaaa;
	}
	.el-table td,
	.el-table th {
		padding: 8px 0 !important;
	}
	textarea{
		outline: none;
	}
	
</style>
